import './open-in-browser-modal.component.scss';

import { h } from 'preact';

import { IconDoNotEnter } from '../../../common/icons/icon-do-not-enter';
import { useTranslation } from '../../../i18n';

interface Props {
  close: () => void;
}

// No button to open the browser for the fan: Instagram's in-app browser on iOS ignored
// x-safari-https, so the modal only tells them how.
export const OpenInBrowserModal = ({ close }: Props) => {
  const { t } = useTranslation();
  return (
    <div class="open-in-browser-modal">
      <div class="single-modal-header">
        <IconDoNotEnter />
        <h3 class="single-modal-title">{t('music.openInBrowserTitle')}</h3>
      </div>
      <div class="single-modal-body">
        <p>{t('music.openInBrowserBody')}</p>
        <p>{t('music.openInBrowserHint')}</p>
      </div>
      <div class="single-modal-footer inline--btns">
        <button class="btn button" onClick={close}>
          {t('common.close')}
        </button>
      </div>
    </div>
  );
};
